export const minsters = [
    "Minister of Health",
    "Minister of Works",
    "Minister of Finance",
    "Minister of Defence",
    "Minister of Education",
    "Minister of Transport",
    "Minister of Home Affairs",
    "Minister of National Unity",
    "Minister of Foreign Affairs",
    "Minister of Human Resources",
    "Minister of Youth and Sports",
    "Minister of Higher Education",
    "Minister of Rural Development",
    "Minister of Federal Territories",
    "Minister of Environment and Water",
    "Minister of Tourism, Arts and Culture",
    "Minister of Housing and Local Government",
    "Minister of Energy and Natural Resources",
    "Minister of Communication and Multimedia",
    "Minister of Agriculture and Food Industries",
    "Minister of International Trade and Industry",
    "Minister of Science, Technology and Innovation",
    "Minister of Domestic Trade and Consumer Affairs",
    "Minister of Plantation Industries and Commodities",
    "Minister of Women, Family and Community Development",
    "Minister of Entrepreneurship Development",
    "Minister of the National Recovery Plan Program",
    "Minister of the National COVID-19 Immunization Program",
]
export const Senior = [
    "Security and Unity",
    "Financial and Economics",
    "Infrastructure Development",
    "Education and Social",
]
export const PMD = [
    "Economy",
    "Special Functions",
    "Parliament and Law",
    "Religious Affairs",
    "Sabah and Sarawak Affairs",
]
export const candidates = [
    { name: "Tan Sri Dato' Hj. Muhyiddin Hj. Mohd. Yassin MP", imageURL: "1-Tan Sri Dato' Hj. Muhyiddin Hj. Mohd. Yassin MP.jfif" },
    { name: "Dato' Sri Ismail Sabri Yaakob MP", imageURL: "2-Dato' Sri Ismail Sabri Yaakob MP.jfif" },
    { name: "Dato' Seri Mohamed Azmin Ali", imageURL: "3-Dato' Seri Mohamed Azmin Ali.jfif" },
    { name: "Dato' Seri Hishammuddin Hussein ", imageURL: "4-Dato' Seri Hishammuddin Hussein.jfif" },
    { name: "Dato' Sri Hj. Fadillah Hj. Yusof", imageURL: "5-Dato' Sri Hj. Fadillah Hj. Yusof.jpg" },
    { name: "Senator Datuk Dr. Mohd. Radzi Md. Jidin", imageURL: "6-Senator Datuk Dr. Mohd. Radzi Md. Jidin.jpeg" },
    { name: "Dato' Sri Mustapa Mohamed", imageURL: "7-Dato' Sri Mustapa Mohamed.jpg" },
    { name: "Datuk Seri Mohd. Redzuan Md. Yusof", imageURL: "8-Datuk Seri Mohd. Redzuan Md. Yusof.jpg" },
    { name: "Datuk Seri Hj. Takiyuddin Hassan", imageURL: "9-Datuk Seri Hj. Takiyuddin Hassan.jfif" },
    { name: "Senator Dato' Seri Dr. Zulkifli Mohamad Al-Bakri", imageURL: "10-Senator Dato' Seri Dr. Zulkifli Mohamad Al-Bakri.jpg" },
    { name: "Datuk Seri Panglima Dr. Maximus Johnity Ongkili", imageURL: "11-Datuk Seri Panglima Dr. Maximus Johnity Ongkili.jpeg" },
    { name: "Tengku Zafrul Tengku Abdul Aziz", imageURL: "12-Tengku Zafrul Tengku Abdul Aziz.jfif" },
    { name: "Dato' Seri Hamzah Zainudin", imageURL: "13-Dato' Seri Hamzah Zainudin.jpg" },
    { name: "Dato' Sri Ustaz Tuan Ibrahim Tuan Man", imageURL: "14-Dato' Sri Ustaz Tuan Ibrahim Tuan Man.jfif" },
    { name: "Tan Sri Datuk Seri Panglima Hj. Annuar Hj. Musa", imageURL: "15Tan Sri Datuk Seri Panglima Hj. Annuar Hj. Musa.jfif" },
    { name: "Datuk Seri Ir. Dr. Wee Ka Siong", imageURL: "16-Datuk Seri Ir. Dr. Wee Ka Siong.jfif" },
    { name: "Datuk Seri Dr. Ronald Kiandee", imageURL: "17-Datuk Seri Dr. Ronald Kiandee.jfif" },
    { name: "Dato' Sri Dr. Adham Baba", imageURL: "18-Dato Sri Dr Adham Baba.jfif" },
    { name: "Dato' Sri Hjh. Nancy Shukri", imageURL: "19-Dato' Sri Hjh. Nancy Shukri.jpeg" },
    { name: "Datuk Hjh. Zuraida Kamaruddin", imageURL: "20-Datuk Hjh. Zuraida Kamaruddin.jpg" },
    { name: "Datuk Seri Dr. Noraini Ahmad", imageURL: "21-Datuk Seri Dr. Noraini Ahmad.jfif" },
    { name: "Datuk Seri Saravanan Murugan", imageURL: "22-Datuk Seri Saravanan Murugan.jpg" },
    { name: "Dato' Sri Alexander Nanta Linggi", imageURL: "23-Dato' Sri Alexander Nanta Linggi.jpg" },
    { name: "Dato' Sri Dr. Hj. Wan Junaidi Tuanku Jaafar", imageURL: "24-Dato' Sri Dr. Hj. Wan Junaidi Tuanku Jaafar.jpg" },
    { name: "Datuk Dr. Hj. Abdul Latiff Hj. Ahmad", imageURL: "25-Datuk Dr. Hj. Abdul Latiff Hj. Ahmad.jpg" },
    { name: "Khairy Jamaluddin", imageURL: "26-Khairy Jamaluddin.jpg" },
    { name: "Datuk Seri Dr. Shamsul Anuar Nasarah", imageURL: "27-Datuk Seri Dr. Shamsul Anuar Nasarah.jpg" },
    { name: "Dato' Ustaz Dr. Mohd. Khairuddin Aman Razali", imageURL: "28-Dato' Ustaz Dr. Mohd. Khairuddin Aman Razali.jpg" },
    { name: "Datuk Seri Rina Mohd. Harun ", imageURL: "29-Datuk Seri Rina Mohd. Harun.jpg" },
    { name: "Datuk Halimah Mohamed Sadique ", imageURL: "30-Datuk Halimah Mohamed Sadique.jpg" },
    { name: "Dato' Sri Reezal Merican Naina Merican ", imageURL: "31-Dato' Sri Reezal Merican Naina Merican.jfif" },
    { name: "Dato' Saifuddin Abdullah", imageURL: "32-Dato' Saifuddin Abdullah.jfif" },
    { name: "Datuk Arthur Joseph Kurup", imageURL: "33-Datuk Arthur Joseph Kurup.jfif" },
    { name: "Datuk Mastura Tan Sri Mohd. Yazid", imageURL: "34-Datuk Mastura Tan Sri Mohd. Yazid.png" },
    { name: "Dato' Eddin Syazlee Shith", imageURL: "35-Dato' Eddin Syazlee Shith.jfif" },
    { name: "Datuk Shabudin Yahaya", imageURL: "36-Datuk Shabudin Yahaya.jfif" },
    { name: "Datuk Ustaz Hj. Ahmad Marzuk Shaary", imageURL: "37-Datuk Ustaz Hj Ahmad Marzuk Shaary.jpg" },
    { name: "Dato' Hjh. Hanifah Hajar Taib", imageURL: "38-Dato' Hjh. Hanifah Hajar Taib.jpg" },
    { name: "Datuk Abdul Rahim Bakri", imageURL: "39-Datuk Abdul Rahim Bakri.jpg" },
    { name: "Mohd. Shahar Abdullah", imageURL: "40-Mohd. Shahar Abdullah.jpg" },
    { name: "Dato' Sri Ikmal Hisham Abdul Aziz", imageURL: "41-Dato' Sri Ikmal Hisham Abdul Aziz.jpg" },
    { name: "Jonathan Yasin", imageURL: "42-Jonathan Yasin.jpg" },
    { name: "Dato' Sri Dr. Hj. Ismail Hj. Mohamed Said", imageURL: "43-Dato' Sri Dr. Hj. Ismail Hj. Mohamed Said.jfif" },
    { name: "Senator Datuk Lim Ban Hong", imageURL: "44-Senator Datuk Lim Ban Hong.jfif" },
    { name: "Muslimin Yahaya", imageURL: "45-Muslimin Yahaya.jpg" },
    { name: "Senator Dato' Dr. Mah Hang Soon", imageURL: "46-Senator Dato' Dr. Mah Hang Soon.jpg" },
    { name: "Dato' Dr. Ahmad Masrizal Muhammad", imageURL: "47-Dato' Dr. Ahmad Masrizal Muhammad.jpg" },
    { name: "Dato' Sri Dr. Edmund Santhara Kumar Ramanaidu", imageURL: "48-Dato' Sri Dr. Edmund Santhara Kumar Ramanaidu.jpg" },
    { name: "Datuk Hj. Hasbi Hj. Habibollah ", imageURL: "49-Datuk Hj. Hasbi Hj. Habibollah.jpg" },
    { name: "Datuk Seri Hj. Ahmad Hamzah", imageURL: "50-Datuk Seri Hj. Ahmad Hamzah.jfif" },
    { name: "Dato' Hj. Che Abdullah Mat Nawi", imageURL: "51-Dato' Hj. Che Abdullah Mat Nawi.jfif" },
    { name: "Dato' Dr. Hj. Noor Azmi Ghazali", imageURL: "52-Dato' Dr. Hj. Noor Azmi Ghazali.jpg" },
    { name: "Datuk Aaron Ago Dagang", imageURL: "53-Datuk Aaron Ago Dagang.jpg" },
    { name: "Datuk Seri Panglima Dr. Jeffrey Gapari Kitingan", imageURL: "54-Datuk Seri Panglima Dr. Jeffrey Gapari Kitingan.jfif" },
    { name: "Senator Datuk Guan Dee Koh Hoi", imageURL: "55-Senator Datuk Guan Dee Koh Hoi.jpg" },
    { name: "Dato' Sri Dr. Hj. Ismail Hj. Abd. Muttalib", imageURL: "56-Dato' Sri Dr. Hj. Ismail Hj. Abd. Muttalib.jpg" },
    { name: "Dato' Hj. Kamarudin Jaffar", imageURL: "57-Dato' Hj. Kamarudin Jaffar.jpg" },
    { name: "Dato' Dr. Mansor Othman", imageURL: "58-Dato' Dr. Mansor Othman.jpg" },
    { name: "Datuk Hj. Awang Hashim", imageURL: "59-Datuk Hj. Awang Hashim.jpg" },
    { name: "Dato' Hj. Rosol Wahid", imageURL: "60-Dato' Hj. Rosol Wahid.jpg" },
    { name: "Datuk Wira Hjh. Mas Ermieyati Hj. Samsudin", imageURL: "61-Datuk Wira Hjh. Mas Ermieyati Hj. Samsudin.jpg" },
    { name: "Dato' Sri Abdul Rahman Mohamad", imageURL: "62-Dato' Sri Abdul Rahman Mohamad.jpg" },
    { name: "Dato Henry Sum Agong", imageURL: "63-Dato Henry Sum Agong.jpg" },
    { name: "Datuk Dr. Shahruddin Md. Salleh ", imageURL: "64-Datuk Dr. Shahruddin Md. Salleh.jfif" },
    { name: "Datuk Hj. Ahmad Amzad Hashim", imageURL: "65-Datuk Hj. Ahmad Amzad Hashim.jfif" },
    { name: "Datuk Ali Anak Biju", imageURL: "66-Datuk Ali Anak Biju.jpg" },
    { name: "Datuk Willie Anak Mongin", imageURL: "67-Datuk Willie Anak Mongin.jfif" },
    { name: "Dato' Sri Dr. Wee Jeck Seng", imageURL: "67-Datuk Willie Anak Mongin.jpg" },
    { name: "Dato' Hjh. Siti Zailah Mohd. Yusoff", imageURL: "68-Dato' Sri Dr. Wee Jeck Seng.jpg" },
    { name: "Senator Dato' Sri Ti Lian Ker", imageURL: "69-Dato' Hjh. Siti Zailah Mohd. Yusoff.jpg" },
    { name: "Senator Wan Ahmad Fayhsal Wan Ahmad Kamal", imageURL: "70-Senator Dato' Sri Ti Lian Ker.jpg" },
    { name: "Datuk Zahidi Zainul Abidin", imageURL: "71-Senator Wan Ahmad Fayhsal Wan Ahmad Kamal.jpeg" },
    { name: "Tun Dr Mahathir Mohamad", imageURL: "72-Datuk Zahidi Zainul Abidin.jpg" },
    { name: "Datuk Seri Dr Wan Azizah Wan Ismail", imageURL: "73-Tun Dr Mahathir Mohamad.jpg" },
    { name: "Datuk Liew Vui Keong", imageURL: "74-Datuk Seri Dr Wan Azizah Wan Ismail.jpg" },
    { name: "Mohamed Hanipa Maidin", imageURL: "75-Datuk Liew Vui Keong.jpg" },
    { name: "Datuk Dr Mujahid Yusof Rawa ", imageURL: "77-Datuk Dr Mujahid Yusof Rawa.jfif" },
    { name: "Fuziah Salleh", imageURL: "78- Fuziah Salleh.jpeg" },
    { name: "Dr Md Farid Rafik ", imageURL: "79-Dr Md Farid Rafik.jpg" },
    { name: "Salahuddin Ayub ", imageURL: "80-Salahuddin Ayub.jfif" },
    { name: "Sim Tze Tzin", imageURL: "81- Sim Tze Tzin.jpg" },
    { name: "Gobind Singh Deo ", imageURL: "82-Gobind Singh Deo.jfif" },
    { name: "Mohamad Sabu", imageURL: "83-Mohamad Sabu.jpg" },
    { name: "Datuk Saifuddin Nasution Ismail", imageURL: "84-Datuk Saifuddin Nasution Ismail.jfif" },
    { name: "Chong Chieng Jen", imageURL: "85-Chong Chieng Jen.jpg" },
    { name: "Datuk Seri Azmin Ali", imageURL: "86-Datuk Seri Azmin Ali.jpg" },
    { name: "Dr Maszlee Malik ", imageURL: "87-Dr Maszlee Malik.jpg" },
    { name: "Teo Ni Ching", imageURL: "88-Teo Ni Ching.jpg" },
    { name: "Redzuan Yusof ", imageURL: "89-Redzuan Yusof.jpg" },
    { name: "Dr Hatta Md Ramli", imageURL: "90-Dr Hatta Md Ramli.jpg" },
    { name: "Yeo Bee Yin", imageURL: "91-Yeo Bee Yin.jpg" },
    { name: "Isnaraissah Munirah Majilis", imageURL: "92-Isnaraissah Munirah Majilis.jfif" },
    { name: "Khalid Samad", imageURL: "93-Khalid Samad.jpg" },
    { name: "Lim Guan Eng", imageURL: "95- Lim Guan Eng.jpg" },
    { name: "Amiruddin Hamzah", imageURL: "96-Amiruddin Hamzah.jpg" },
    { name: "Dr Dzulkefly Ahmad", imageURL: "97-Dr Dzulkefly Ahmad.jpg" },
    { name: "Dr Lee Boon Chye", imageURL: "98-Dr Lee Boon Chye.jpg" },
    { name: "Azis Jamman", imageURL: "99-Azis Jamman.jpg" },
    { name: "M. Kulasegaran", imageURL: "100-M. Kulasegaran.jfif" },
    { name: "Datuk Mahfuz Omar", imageURL: "101-Datuk Mahfuz Omar.jfif" },
    { name: "Darell Leiking", imageURL: "102-Darell Leiking.jfif" },
    { name: "Dr Ong Kian Ming ", imageURL: "103-Dr Ong Kian Ming.jpg" },
    { name: "Dr Xavier Jayakumar", imageURL: "104-Dr Xavier Jayakumar.jpg" },
    { name: "Tengku Zulpuri Shah", imageURL: "105-Tengku Zulpuri Shah.jpg" },
    { name: "Teresa Kok ", imageURL: "106-Teresa Kok.jfif" },
    { name: "Shamsul Iskandar Md Akin", imageURL: "107-Shamsul Iskandar Md Akin.jfif" },
    { name: "R. Sivarasa", imageURL: "108-R. Sivarasa.jpg" },
    { name: "Datuk Mohamad Din Ketapi", imageURL: "109-Datuk Mohamad Din Ketapi.jpg" },
    { name: "Muhammad Bakhtiar Wan Chik", imageURL: "110-Muhammad Bakhtiar Wan Chik.jfif" },
    { name: "Anthony Loke ", imageURL: "111-Anthony Lokeÿ.jfif" },
    { name: "Hannah Yeoh", imageURL: "112-Hannah Yeoh.jpg" },
    { name: "Baru Bian", imageURL: "113-Baru Bian.jpg" },
    { name: "Annuar Mohd Tahir ", imageURL: "114-Annuar Mohd Tahir.jpg" },
    { name: "Syed Saddiq Abdul Rahman", imageURL: "115-Syed Saddiq Abdul Rahman.jpg" },
    { name: "Steven Sim Chee Keong ", imageURL: "116- Steven Sim Chee Keong.jfif" },
    { name: "Dr. Ahmad Zahid Hamidi", imageURL: "117-Dr. Ahmad Zahid Hamidi.jpg" },
    { name: "Mohd. Najib Abdul Razak", imageURL: "118-Mohd. Najib Abdul Razak.jpg" },
    { name: "Dr. Shahidan Kassim", imageURL: "119-Dr. Shahidan Kassim.jfif" },
    { name: "Maj. Gen. (Rtd.) Jamil Khir Baharom", imageURL: "120-Idr. Jazzbi Chew.jpg" },
    { name: "Idris Jala", imageURL: "121-Idris Jala.jpg" },
    { name: "Abdul Wahid Omar", imageURL: "122-Abdul Wahid Omar.jfif" },
    { name: "Paul Low Seng Kwan", imageURL: "123-Paul Low Seng Kwan.jfif" },
    { name: "Joseph Entulu Belaun", imageURL: "124-Joseph Entulu Belaun.jfif" },
    { name: "Mah Siew Keong", imageURL: "125-Mah Siew Keong.jfif" },
    { name: "Azalina Othman Said", imageURL: "126-Azalina Othman Said.jpg" },
    { name: "Abdul Rahman Dahlan", imageURL: "127-Abdul Rahman Dahlan.jpg" },
    { name: "Ahmad Husni Hanadzlah", imageURL: "128-Ahmad Husni Hanadzlah.jfif" },
    { name: "Johari Abdul Ghani", imageURL: "129-Johari Abdul Ghani.jpg" },
    { name: "Ong Ka Chuan", imageURL: "130-Ong Ka Chuan.jpg" },
    { name: "Idris Jusoh", imageURL: "131-Idris Jusoh.jfif" },
    { name: "Mahdzir Khalid", imageURL: "132-Mahdzir Khalid.jpg" },
    { name: "Palanivel Govindasamy", imageURL: "133-Palanivel Govindasamy.jpg" },
    { name: "Tengku Adnan Tengku Mansor", imageURL: "134-Tengku Adnan Tengku Mansor.jpg" },
    { name: "Liow Tiong Lai", imageURL: "135-Liow Tiong Lai.jfif" },
    { name: "Ahmad Shabery Cheek", imageURL: "136-Ahmad Shabery Cheek.jpg" },
    { name: "Subrmaniam Sathasivam", imageURL: "137-Subrmaniam Sathasivam.jpg" },
    { name: "Mohamed Nazri Abdul Aziz", imageURL: "138-Mohamed Nazri Abdul Aziz.jfif" },
    { name: "Noh Omar", imageURL: "139-Noh Omar.jpg" },
    { name: "Anifah Aman", imageURL: "140-.jpg" },
    { name: "Richard Riot Jaem", imageURL: "141-Richard Riot Jaem.jpg" },
    { name: "Hasan Malek", imageURL: "142-Hasan Malek.jpg" },
    { name: "Shafie Apdal", imageURL: "143-Shafie Apdal.jpg" },
    { name: "Dr. Ewon Ebin", imageURL: "144-Dr. Ewon Ebin.jpg" },
    { name: "Wilfred Madius Tangau", imageURL: "145-Wilfred Madius Tangau.jpg" },
    { name: "Douglas Uggah Embas", imageURL: "146-Douglas Uggah Embas.jpg" },
    { name: "Mah Siew Kiong", imageURL: "147-Mah Siew Kiong.jfif" },
    { name: "Rohani Abdul Karim", imageURL: "148-Rohani Abdul Karim.jfif" },
    { name: "Dr. Mohd. Salleh Said", imageURL: "149-Dr. Mohd. Salleh Said.jpg" },
    { name: "Razali Ibrahim", imageURL: "150-Razali Ibrahim.jfif" },
    { name: "Waytha Moorthy Ponnusamy", imageURL: "151-Waytha Moorthy Ponnusamy.jpg" },
    { name: "Dr. Asyraf Wajdi Dusuki", imageURL: "152-Dr. Asyraf Wajdi Dusuki.jpg" },
    { name: "Devamany S. Krishnasamy", imageURL: "153-Devamany S. Krishnasamy.jpg" },
    { name: "Ahmad Maslan", imageURL: "154-Ahmad Maslan.jpg" },
    { name: "Chua Tee Yong", imageURL: "155-Chua Tee Yong.jpg" },
    { name: "Othman Aziz", imageURL: "156-Othman Aziz.jpg" },
    { name: "Lee Chee Leong", imageURL: "157-Lee Chee Leong.jpeg" },
    { name: "Mohd. Johari Baharum", imageURL: "158-Mohd. Johari Baharum.jpg" },
    { name: "Nur Jazlan Mohamed", imageURL: "159-Nur Jazlan Mohamed.jpg" },
    { name: "Masir Kujat", imageURL: "160-Masir Kujat.jpg" },
    { name: "Hamim Samuri", imageURL: "161-Hamim Samuri.jpg" },
    { name: "Kamalanathan Panchanathan", imageURL: "162-Kamalanathan Panchanathan.jpg" },
    { name: "Mary Yap Kain Ching", imageURL: "163-Mary Yap Kain Ching.jpg" },
    { name: "Chong Sin Woon", imageURL: "164-Chong Sin Woon.jpg" },
    { name: "Dr. James Dawos Mamit", imageURL: "165-Dr. James Dawos Mamit.jfif" },
    { name: "Loga Bala Mohan Jaganathan", imageURL: "166-Loga Bala Mohan Jaganathan.jfif" },
    { name: "Abdul Aziz Kaprawi", imageURL: "167-Abdul Aziz Kaprawi.jfif" },
    { name: "Tajuddin Abdul Rahman", imageURL: "168-Dato' Sri Abdul Rahman Mohamad.jpg" },
    { name: "Nogeh Gumbek", imageURL: "169-Nogeh Gumbek.jpg" },
    { name: "Dr. Hilmi Yahya", imageURL: "170-Dr. Hilmi Yahya.jpg" },
    { name: "Mas Ermieyati Samsudin", imageURL: "171-Mas Ermieyati Samsudin.jpg" },
    { name: "Ahmad Bashah Md. Hanipah", imageURL: "172-Ahmad Bashah Md. Hanipah.jpg" },
    { name: "Ahmad Jazlan Yaakub", imageURL: "173-Ahmad Jazlan Yaakub.jpg" },
    { name: "Rosnah Abdul Rashid Shirlin", imageURL: "174-Rosnah Abdul Rashid Shirlin.jfif" },
    { name: "Dr. Abu Bakar Mohamad Diah", imageURL: "175-Dr. Abu Bakar Mohamad Diah.jpg" },
    { name: "Datu Nasrun Datu Mansur", imageURL: "176-Datu Nasrun Datu Mansur.jpg" },
    { name: "Dato' Hajjah Azizah binti Mohd Dun ", imageURL: "177-Dato' Hajjah Azizah binti Mohd Dun.jfif" },
    { name: "Datin Paduka Chew Mei Fun", imageURL: "178-Datin Paduka Chew Mei Fun.jpg" },
    { name: "Jailani Johari", imageURL: "179-Jailani Johari.jpg" },
]